import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    currentList: []
  },
  getters: {},
  mutations: {
    setCurrentList (state, currentList) {
      state.currentList = currentList
    }
  },
  actions: {
    async storeInspectionTypeList ({rootState, commit}) {
      commit('setCurrentList', await api.getInspectionTypes(rootState.project.current.type === rootState.enumData.projectType.sheet.value ? rootState.project.current.parent : rootState.project.current._id))
    },
    getInspectionTypeListById ({state}, projectId) {
      return api.getInspectionTypes(projectId)
    },
    getInspectionType ({commit}, _id) {
      return api.getInspectionType(_id)
    },
    async delete ({commit, dispatch, state}, inspectionTypeId) {
      await api.deleteInspectionType(inspectionTypeId)
      await dispatch('storeInspectionTypeList')
    },
    async add ({rootState, dispatch}, inspectionType) {
      const template = inspectionType.template
      delete inspectionType.template

      const _id = await api.addInspectionType({
        ...inspectionType,
        project: rootState.project.current._id
      })

      await dispatch('uploadTemplate', {_id: _id, file: template})
    },
    async update ({dispatch}, inspectionType) {
      const template = inspectionType.template instanceof File ? inspectionType.template : null

      delete inspectionType.template

      await api.updateInspectionType(inspectionType)

      if (template) await dispatch('uploadTemplate', {_id: inspectionType._id, file: template})
    },
    async copy ({dispatch}, _id) {
      await api.copyInspectionType(_id)
    },
    async uploadTemplate ({state}, {_id, file}) {
      const {location} = await api.addInspectionTypeTemplateMeta(_id, {name: file.name, extension: file.name.split('.').pop()})

      await api.addInspectionTypeTemplateContent(location, file)
    },
    async testTemplate ({rootState}, {inspectionType, template}) {
      const result = await api.testInspectionType(rootState.project.current._id, inspectionType, template)

      require('downloadjs')(result, `測試_${inspectionType.name}.docx`)
    },
    async importInspectionTypes ({rootState}, ids) {
      await api.importInspectionTypes(rootState.project.current._id, ids)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inspectionType.js